module.exports = __webpack_public_path__ + "static/img/aboutus_img4.8bc00b4f.png";